import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss']
})
export class DashboardCardComponent {
  @Input() title = '';
  @Input() value = '';
  @Input() sub = '';
  @Input() icon!: 'eye' | 'eye-off' | 'dashboard' | 'users' | 'store' | 'user' | 'doc' | 'card' | 'dollar' | 'user-circle' | 'bell' | 'arrow-up';
}
